export class CrossResourceQueryRequest {
    'resources';
    'query';
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resources",
            "baseName": "resources",
            "type": "Array<CrossResourceQueryRequestResourcesInner>",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "QueryDBRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CrossResourceQueryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
